{
  "$id": "module://transaction-config",
  "$schema": "wealthlane://schemas/domain",
  "title": "Transaction Configuration",
  "description": "Company transaction configuration (price threshold, acquisition type, share registration)",
  "type": "object",
  "properties": {
    "priceThreshold": {
      "type": "number",
      "title": "Price Threshold",
      "widget": "number",
      "minimum": 0,
      "inputPrecision": 4,
      "displayPrecision": 4
    },
    "transactionAcquisitionTypeId": {
      "type": "string",
      "title": "Acquisition Type",
      "widget": "select"
    },
    "intendedShareRegistrationTypeId": {
      "type": "string",
      "title": "Intended Share Registration Type",
      "widget": "select"
    }
  }
}
